<template>
  <div>
    <v-header></v-header>

    <div class="content">
      <div class="left">
        <div class="user">
          <div class="user-info">
            <div class="imgs">
              <img
                src="@/assets/img/avatar.gif"
                alt=""
              />
            </div>
            <div class="boxs">
              <p class="name">{{ userInfo.name + $parseLabel('，您好！') }}</p>
              <p class="department">{{ userInfo.postName }}</p>
              <div class="item">
                <div class="list">
                  <p>{{ $parseLabel('工号') }}</p>
                  <p>{{ userInfo.jobNum }}</p>
                </div>

                <div class="list">
                  <p>{{ $parseLabel('邮箱') }}</p>
                  <p>{{ userInfo.email }}</p>
                </div>

                <p class="list pws" @click="upStatus = true">{{ $parseLabel('修改密码') }}</p>
              </div>
            </div>
          </div>
          <div class="user-up"></div>
        </div>

        <div class="entrance">
          <div class="ebox">
            <h3>{{ $parseLabel('快捷入口') }}</h3>
            <div class="item">

              <el-tag
                v-for="(item, index) in userSysList"
                :key="index"
                @click="$encryption(item.path, 'home')"
                @close="handleClose(item)"
                class="list"
                closable
              >
                {{ item.title }}
              </el-tag>
              <div class="list" @click="handleAddEntry">
                <p>+</p>
              </div>
            </div>
          </div>
        </div>

        <div class="matter">
          <div class="mbox">
            <h3>
              {{ $parseLabel('待处理事项') }}
              <el-input
                v-model="title"
                size="small"
                :placeholder="$parseLabel('请输入内容')"
              ></el-input>
            </h3>
            <div class="item">
              <div class="list">
                <div class="lboxs">
                  <div class="img">
                    <img src="@/assets/img/1.png" alt="" />
                  </div>
                  <p>{{ $parseLabel('待处理') }}</p>
                </div>
                <div class="lnumber">
                  <p>{{ todoInfo.pending }}</p>
                  <span>{{ $parseLabel('条') }}</span>
                </div>
              </div>

              <div class="list">
                <div class="lboxs">
                  <div class="img">
                    <img src="@/assets/img/2.png" alt="" />
                  </div>
                  <p>{{ $parseLabel('已处理') }}</p>
                </div>
                <div class="lnumber">
                  <p>{{ todoInfo.processed }}</p>
                  <span>{{ $parseLabel('条') }}</span>
                </div>
              </div>

              <div class="list">
                <div class="lboxs">
                  <div class="img">
                    <img src="@/assets/img/3.png" alt="" />
                  </div>
                  <p>{{ $parseLabel('逾期未处理') }}</p>
                </div>
                <div class="lnumber">
                  <p>{{ todoInfo.rejected }}</p>
                  <span>{{ $parseLabel('条') }}</span>
                </div>
              </div>
            </div>
            <ul>
              <li
                v-for="(item, index) in todoList"
                :key="index"
                :style="
                  index % 2 == 0
                    ? 'background-color: #f6faff'
                    : 'background-color: #fff'
                "
              >
                <div class="cons">
                  <p>{{ item.title }}</p>
                  <span>{{ $parseLabel('申请时间') + ': ' + item.createdTime }}</span>
                </div>
                <div class="status">
                  {{ item.status == 1 ? "已处理" : "" }}
                  <el-button
                    @click="jump(item)"
                    v-if="item.status == 0"
                    type="warning"
                    size="mini"
                    >{{ $parseLabel('去处理') }}</el-button
                  >
                </div>
              </li>
              <div class="pagination">
                <el-pagination
                  @size-change="handleSizeChange"
                  @current-change="pageChange"
                  :page-sizes="[10, 50, 100, 150, 200]"
                  :page-size="pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="todoInfo.total"
                  background
                ></el-pagination>
              </div>
            </ul>
          </div>
        </div>
      </div>
      <div class="right">
        <div class="warning">
          <h3>{{ $parseLabel('预警提示') }}</h3>
          <div class="list l1">
            <img src="@/assets/img/22.png" alt="" />
            <div class="boxs">
              <p>2023-11-28 13:20:00</p>
              <span>用于表示普通操作信息提示</span>
            </div>
          </div>

          <div class="list l2">
            <img src="@/assets/img/11.png" alt="" />
            <div class="boxs">
              <p>2023-11-28 13:20:00</p>
              <span>用于表示严重操作信息提示，优先处理</span>
            </div>
          </div>
        </div>

        <div class="news">
          <h3>
            {{ $parseLabel('公告通知') }}
            <p @click="jumpMore(1)">{{ $parseLabel('更多') }}</p>
          </h3>
          <div
            class="list"
            v-for="(notificationItem, index) in notificationList"
            :key="index"
            @click="open(notificationItem)"
          >
            <p>{{ notificationItem.title }}</p>
            <span>{{ $parseLabel('查看') }}</span>
          </div>
        </div>

        <div class="news">
          <h3>
            {{ $parseLabel('帮助中心') }}
            <p @click="jumpMore(2)">{{ $parseLabel('更多') }}</p>
          </h3>
          <div
            class="list"
            v-for="(fileItem, index) in fileList"
            :key="index"
            @click="openDoc(fileItem)"
          >
            <p>{{ fileItem.name }}</p>
            <span>{{ $parseLabel('查看') }}</span>
          </div>
        </div>
      </div>
    </div>

    <v-footer></v-footer>

    <el-dialog :title="$parseLabel('提示')" :visible.sync="dataDialogVisible" width="30%">
      <span>{{ content }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dataDialogVisible = false"
          >{{ $parseLabel('我已知晓') }}</el-button
        >
      </span>
    </el-dialog>

    <el-dialog :title="$parseLabel('选择快捷入口')" :visible.sync="dialogVisible" width="400px">
      <!-- <el-input
        placeholder="请输入快捷入口名称"
        v-model="data.title"
      ></el-input> -->

      <el-select
        style="width: 100%"
        v-model="value1"
        multiple
        :placeholder="$parseLabel('请选择')"
      >
        <el-option
          style="width: 100%"
          v-for="item in sysList"
          :key="item.name"
          :label="item.name"
          :value="item.name"
          :disabled="item.status == 0"
        >
        </el-option>
      </el-select>

      <!-- <el-input placeholder="请输入快捷入口链接" v-model="data.path"></el-input> -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">{{ $parseLabel('取 消') }}</el-button>
        <el-button type="primary" @click="submitEntry">{{ $parseLabel('确 定') }}</el-button>
      </span>
    </el-dialog>

    <div class="up" v-show="upStatus">
      <div class="datas">
        <div class="left">
          <div class="bg"></div>
        </div>
        <div class="right">
          <h3>{{ $parseLabel('修改密码') }}</h3>
          <el-input
            v-model="pws.oldPassword"
            show-password
            :placeholder="$parseLabel('请输入原始密码')"
          ></el-input>
          <el-input
            v-model="pws.password"
            show-password
            :placeholder="$parseLabel('请输入新密码')"
          ></el-input>
          <el-input
            v-model="pws.yes_password"
            show-password
            :placeholder="$parseLabel('请输入重复密码')"
          ></el-input>
          <div class="btn">
            <el-button @click="savePws()" type="primary">{{ $parseLabel('确定') }}</el-button>
            <el-button @click="upStatus = false">{{ $parseLabel('取消') }}</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
    
  <script>
import {
  getTodoList,
  getNotificationList,
  getFileList,
  getApplicationList,
  getSysList,
  addSysList,
} from "@/api/list";
import { getDocumentByPath } from "@/api/kpi"
import { up, checkToken, logout } from "@/api/user";
import header from "@/components/header.vue";
import footer from "@/components/footer.vue";
import axios from "axios";
import moment from "moment";

export default {
  data() {
    return {
      pageSize: 10,
      pageNum: 1,
      total: 0,
      list: [],
      todoList: [],
      todoInfo: {},
      notificationList: [],
      fileList: [],
      sysList: [],
      userSysList: [],
      userInfo: {},
      dialogVisible: false,
      dataDialogVisible: false,
      data: {},
      pws: {
        oldPassword: "",
        password: "",
        yes_password: "",
      },
      value1: [],
      content: "",
      title: "",
      upStatus: false,
    };
  },
  components: {
    "v-header": header,
    "v-footer": footer,
  },
  created() {
    checkToken().then((res) => {
      if (res.success) {
        this.$doGetProfile();
        //this.doGetVoiceList();
        this.doGetTodoList();
        this.doGetNotificationList();
        this.doGetFileList();
        this.doGetSysList("home");
      } else {
        this.$router.push({
          path: "/",
        });
      }
    });
  },
  watch: {
    "$store.state.userData": {
      handler() {
        this.userInfo = Object.assign({}, this.$store.state.userData);
      },
    },
    dialogVisible(val) {
      if (val) {
        getApplicationList("home").then((res) => {
          if (res.success) {
            this.sysList = res.data.list.filter(item => item.url != null && item.url !== '');
          }
        });
      }

      if (!val) {
        this.value1 = [];
      }
    },
    title(val) {
      if (val != null) {
        this.pageNum = 1;
        this.doGetTodoList();
      } else {
        console.log("title val: ", val);
      }
    },
  },
  methods: {
    handleSizeChange(e) {
      this.pageSize = e;
      this.doGetTodoList();
    },
    pageChange(e) {
      this.pageNum = e;
      this.doGetTodoList();
    },
    handleClose(list) {
      let that = this;
      axios
        .delete(that.apiSettings.ADMINURL +  "/sys_entry/" + list.id, {
          headers: {
            Authorization: "Bearer " + sessionStorage.getItem("access_token"),
          },
        })
        .then(function (res) {
          //注意data属性是固定的用法，用于获取后台的实际数据
          if (res.data.success) {
            that.msgSuccess("删除成功");
            that.doGetSysList("home");
          }
        });
    },
    jump(item) {
      window.open(item.url);
    },
    jumpMore(type) {
      this.$router.push({
        path: "/notice",
        query: {
          type: type,
        },
      });
    },
    open(list) {
      this.content = list.content;
      this.dataDialogVisible = true;
    },
    // openDoc(item) {
    //   let _this = this;
    //   if (_this.isURL(item.path) === true) {
    //     window.open(item.path)
    //   } else {
    //     if (_this.isNumber(item.path) === true) {
    //       getDocumentByPath(parseInt(item.path)).then(res => {
    //         if (res.success) {
    //           window.open(res.data.path)
    //         }
    //       }).catch(err=>{
    //         _this.msgError(err);
    //       });
    //     }
    //   }
    // },
    openDoc(item) {
      let _this = this;
      if (_this.isURL(item.path) === true) {
        _this.handleFileDownload(item.name, item.path);
      } else {
        if (_this.isNumber(item.path) === true) {
          getDocumentByPath(parseInt(item.path)).then(res => {
            if (res.success) {
              _this.handleFileDownload(item.name, res.data.path);
            }
          }).catch(err=>{
            _this.msgError(err);
          });
        }
      }
    },
    handleFileDownload(fileName, fileUrl) {
      let realFileName = fileName + moment().format('YYYYMMDDHHmmSS');
      let fileSuffix = fileUrl.substring(fileUrl.lastIndexOf("."));
      const downloadFileName = realFileName + fileSuffix;

      this.ccxGetBlob(fileUrl).then(blob => {
        this.ccxSaveAs(blob, downloadFileName)
      })
    },
    isNumber(value) {
      return !isNaN(parseFloat(value)) && isFinite(value);
    },
    savePws() {
      if (!this.pws.oldPassword) {
        return this.msgError("请输入原始密码");
      }
      if (!this.pws.password) {
        return this.msgError("请输入新密码");
      }
      if (!this.pws.yes_password) {
        return this.msgError("请输入重复密码");
      }

      if (this.pws.password != this.pws.yes_password) {
        return this.msgError("两次密码输入不正确");
      }

      let _this = this;
      up({
        oldPassword: this.$md5(this.pws.oldPassword),
        password: this.$md5(this.pws.password),
      }).then((res) => {
        if (res.success) {
          _this.msgSuccess("密码修改成功");
          _this.upStatus = false;
          logout().then(() => {
            _this.$store.commit("logout");
            setTimeout(() => {
              _this.$redirectToLogin();
            }, 500);
          }).catch(() => {
            _this.$store.commit("logout");
            setTimeout(() => {
              _this.$redirectToLogin();
            }, 500);
          });
        } else {
          _this.msgError(res.message);
        }
      });
    },
    handleAddEntry() {

      this.value1 = [];
      if(false === this.isEmpty(this.userSysList)) {
        this.value1 = this.userSysList.map(u=>u.title);
      }
      this.dialogVisible = true;
    },
    submitEntry() {
      let entries = [];
      this.sysList.forEach((sysItem) => {
        this.value1.forEach((item) => {
          if (sysItem.name == item) {
            entries.push({
              path: sysItem.url,
              title: sysItem.name,
            });
          }
        });
      });

      addSysList({
        appCode: "home",
        entries: entries,
      }).then((res) => {
        if (res.success) {
          this.msgSuccess("添加成功");
          this.doGetSysList("home");
          this.dialogVisible = false;
        }
      });
    },
    // doGetVoiceList() { 
    //   getVoiceList(this.pageNum, this.pageSize).then((res) => {
    //     if (res.success) {
    //       this.list = res.data.list;
    //     }
    //   });
    // },
    doGetTodoList() {
      getTodoList(this.pageNum, this.pageSize, this.title).then((res) => {
        if (res.success) {
          res.data.list.list.forEach((item) => {
            item.createdTime = moment(item.createdTime).format("YYYY-MM-DD HH:mm:ss");
          });
          this.todoInfo.pending = res.data.pending;
          this.todoInfo.processed = res.data.processed;
          this.todoInfo.rejected = res.data.rejected;
          this.todoInfo.total = res.data.list.total;
          this.todoList = res.data.list.list;
        }
      });
    },
    doGetNotificationList() {
      getNotificationList(this.pageNum, this.pageSize).then((res) => {
        if (res.success) {
          this.notificationList = res.data.list;
        }
      });
    },
    doGetFileList() {
      getFileList(this.pageNum, this.pageSize).then((res) => {
        if (res.success) {
          this.fileList = res.data.list;
        }
      });
    },
    doGetSysList(type) {
      getSysList(type).then((res) => {
        if (res.success) {
          this.userSysList = res.data;
        }
      });
    },
  },
};
</script>
    
<style lang="less" scoped>
.content {
  width: 85%;
  margin: 30px auto;
  height: auto;
  display: flex;
  justify-content: space-between;
}

.content .left {
  /* width: 68%; */
  width: calc(100% - 480px);
}

.content .right {
  /* width: calc(100% - 300px); */
  width: 470px;
}
.content .left .user {
  width: 100%;
  height: 100px;
  background-color: #fff;
}

.user-info {
  height: 100%;
  display: flex;
  align-items: center;
  position: relative;
  .pws {
    position: absolute;
    right: 0;
    cursor: pointer;
  }
}

.user-info .imgs {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  margin-left: 20px;
  margin-right: 20px;
}

.user-info .imgs img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
}

.user-info .boxs {
  display: flex;
  flex-direction: column;
}

.user-info .boxs .name {
  color: #000;
  font-weight: 800;
}

.user-info .boxs .department {
  font-size: 14px;
  margin-top: 5px;
  margin-bottom: 5px;
}

.user-info .boxs .item {
  display: flex;
}

.user-info .boxs .item .list {
  display: flex;
  margin-right: 20px;
  font-size: 14px;
}

.user-info .boxs .item .list p {
  margin-right: 10px;
}

.entrance {
  width: 100%;
  height: auto;
  background: #fff;
  margin-top: 20px;
  padding-bottom: 15px;
}

.entrance .item {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.ebox {
  width: 95%;
  margin: auto;
}

.ebox h3 {
  height: 50px;
  line-height: 50px;
  font-size: 15px;
}

.entrance .list {
  width: auto;
  height: 30px;
  line-height: 30px;
  background: #ffffff;
  border-radius: 30px;
  border: 1px solid rgba(0, 45, 126, 0.5);
  padding-left: 25px;
  padding-right: 25px;
  color: #002d7e;
  font-weight: 600;
  font-size: 12px;
  text-align: center;
  margin-right: 10px;
  cursor: pointer;
}

.xz {
  background: linear-gradient(90deg, #2280fb 0%, #43a2ff 100%) !important;
  box-shadow: 0px 2px 8px 0px rgba(0, 45, 126, 0.6);
  color: #fff !important;
  border: 1px solid #2280fb !important;
}

.matter {
  width: 100%;
  height: auto;
  background: #fff;
  margin-top: 20px;
  padding-bottom: 10px;
}

.matter .mbox {
  width: 95%;
  margin: auto;
}

.matter .mbox h3 {
  height: 50px;
  line-height: 50px;
  font-size: 15px;
  display: flex;
  justify-content: space-between;
  .el-input {
    width: 200px;
    height: 50px;
  }
}

.matter .mbox .item {
  display: flex;
  justify-content: space-between;
  position: relative;
  margin: 10px 0;
}

.matter .mbox .item .list {
  width: 32%;
  height: 80px;
  display: flex;
  justify-content: space-between;
  background-color: #f6faff;
  box-shadow: inset 0px 0px 50px 0px rgba(69, 145, 255, 0.1);
  border-radius: 8px;
  box-shadow: 5px 4px 15px 0px #0000004b;
}

.matter .mbox .item .list .lboxs {
  height: 100%;
  display: flex;
  align-items: center;
}

.matter .mbox .item .list .lboxs img {
  width: 50px;
  height: 50px;
  border-radius: 10px;
  margin-top: 5px;
  margin-left: 10px;
  margin-right: 5px;
}

.matter .mbox .item .list .lboxs p {
  color: #333333;
  font-size: 15px;
  font-weight: 800;
}

.lnumber {
  height: 100%;
  display: flex;
  align-items: center;
  margin-right: 15px;
}

.lnumber p {
  color: #002d7e;
  font-weight: 800;
  font-size: 18px;
}

.lnumber span {
  font-size: 13px;
  margin-left: 5px;
  display: block;
}

.matter .mbox ul {
  margin-top: 20px;
}

.matter .mbox ul li {
  width: 100%;
  height: auto;
  list-style: none;
  display: flex;
  justify-content: space-between;
}

.matter .cons {
  display: flex;
  flex-direction: column;
  text-indent: 15px;
  padding-top: 6px;
  padding-bottom: 6px;
}

.matter .cons p {
  color: #192c7d;
  font-weight: 800;
  font-size: 15px;
}

.matter .cons span {
  color: #666666;
  font-size: 13px;
  padding-top: 3px;
}

.matter .status {
  display: flex;
  align-items: center;
  position: relative;
  right: 15px;
  font-size: 14px;
}

.content .right .top {
  width: 100%;
  height: 230px;
  display: flex;
  justify-content: space-between;
}

.content .right .top .list {
  width: 24%;
  display: flex;
  flex-direction: column;
}

.content .right .top .list h3 {
  font-size: 16px;
  text-indent: 15px;
  padding-top: 30px;
}

.content .right .top .list p {
  font-size: 30px;
  font-weight: 800;
  text-indent: 15px;
  padding-top: 20px;
}

.content .right .warning {
  width: 100%;
  height: auto;
  background: #fff;
  // margin-top: 20px;
  padding-bottom: 5px;
}

.content .right .warning h3 {
  width: 95%;
  height: 50px;
  line-height: 50px;
  font-size: 17px;
  margin: auto;
}

.content .right .warning .l1 {
  border: 1px solid #60acfc;
  background: #e8f3fe;
}

.content .right .warning .l2 {
  border: 1px solid #ffc310;
  background: #fff9e7;
}

.warning .list {
  width: 95%;
  height: 55px;
  margin: auto;
  display: flex;
  border-radius: 5px;
  margin-bottom: 10px;
}

.warning .list .boxs {
  position: relative;
  top: 5px;
}

.warning .list .boxs p {
  color: #333333;
  font-weight: 700;
  font-size: 14px;
  margin-bottom: 3px;
}

.warning .list .boxs span {
  color: #666666;
  font-size: 12px;
  display: block;
}

.warning .list img {
  width: 20px;
  height: 20px;
  margin-left: 10px;
  margin-right: 10px;
  position: relative;
  top: 7px;
}

.news {
  width: 100%;
  height: auto;
  padding-bottom: 5px;
  background: #fff;
  margin-top: 10px;
}

.content .right .news h3 {
  width: 95%;
  height: 50px;
  line-height: 50px;
  font-size: 17px;
  margin: auto;
  display: flex;
  justify-content: space-between;
  p {
    font-size: 12px;
    cursor: pointer;
  }
}

.content .right .news .list {
  width: 95%;
  margin: auto;
  display: flex;
  justify-content: space-between;
  cursor: pointer;
  margin-bottom: 13px;
}

.content .right .news .list p {
  font-size: 14px;
  width: 90%;
  overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.content .right .news .list span {
  color: #002d7e;
  font-weight: 800;
  font-size: 14px;
}

.up {
  width: 100%;
  height: 100vh;
  position: fixed;
  background: rgba(0, 0, 0, 0.6);
  left: 0;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9;
  .datas {
    width: 800px;
    height: 500px;
    background: #fff;
    display: flex;
    padding-right: 20px;
    .left {
      width: 50%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      .bg {
        width: 90%;
        height: 90%;
        background: url("../../assets/img/bg.jpg") no-repeat;
        background-size: 100% 100%;
      }
    }
    .right {
      width: 45%;
      height: 100%;
      display: flex;
      flex-direction: column;
      h3 {
        margin-top: 60px;
        margin-bottom: 40px;
        font-size: 30px;
      }
      .el-input {
        margin-bottom: 15px;
      }
    }
  }
  .btn {
    width: 90%;
    margin: auto;
    .el-button {
      width: 50%;
      height: 45px;
    }
  }
}
</style>
